import { createReducer, on } from '@ngrx/store';
import * as PricingActions from './pricing.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { IPricingGroup } from '@boma/supplier-portal/shared/entities';

export const pricingFeatureKey = 'pricing';

export interface PricingState extends EntityState<IPricingGroup> {
  loaded: boolean;
  selected?: { id: string; loaded: boolean } | null;
  error?: string | null;
  createError?: string | null;
  updating: boolean;
}

export const pricingTierEntityAdapter: EntityAdapter<IPricingGroup> = createEntityAdapter<
  IPricingGroup
>();

export const pricingInitialState: PricingState = pricingTierEntityAdapter.getInitialState(
  {
    entities: {},
    loaded: false,
    selected: null,
    error: null,
    updating: false,
    createError: null,
    ids: [],
  }
);

export const pricingReducer = createReducer(
  pricingInitialState,

  on(PricingActions.loadPricings, (state, { payload }) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(PricingActions.loadPricingsSuccess, (state, action) => {
    const res = pricingTierEntityAdapter.upsertMany(action.data, {
      ...state,
      loaded: true,
      error: null,
    });
    console.log('LOAD PRICING', res);
    return res;
  }),
  on(PricingActions.loadPricingsFailure, (state, action) => ({
    ...state,
    loaded: false,
    error: action.error,
  })),
  on(PricingActions.createPricingGroup, (state, action) => {
    console.log('Create pricing group', action.payload);
    return {
      ...state,
      updating: true,
      createError: null,
    };
  }),
  on(PricingActions.createPricingGroupSuccess, (state, action) => {
    const res = pricingTierEntityAdapter.upsertOne(action.payload as any, {
      ...state,
      selected: { id: action.payload.id, loaded: true },
      updating: false,
      createError: null,
    });
    console.log('Result', res);
    return res;
  }),
  on(PricingActions.createPricingGroupFailure, (state, action) => ({
    ...state,
    updating: false,
    createError: action.error,
  })),

  on(PricingActions.updatePricingGroup, (state, action) => {
    console.log('Update pricing group', action.payload);
    return {
      ...state,
      updating: true,
      createError: null,
    };
  }),
  on(PricingActions.updatePricingGroupSuccess, (state, action) => {
    return pricingTierEntityAdapter.upsertOne(action.payload as any, {
      ...state,
      selected: { id: action.payload.id, loaded: true },
      updating: false,
      createError: null,
    });
  }),
  on(PricingActions.updatePricingGroupFailure, (state, action) => ({
    ...state,
    updating: false,
    createError: action.error,
  })),
  on(PricingActions.deletePricingGroup, (state, action) => {
    return {
      ...state,
      updating: true,
      createError: null,
    };
  }),
  on(PricingActions.deletePricingGroupSuccess, (state, action) => {
    return pricingTierEntityAdapter.removeOne(action.groupId as any, {
      ...state,
      updating: false,
      createError: null,
    });
  }),
  on(PricingActions.deletePricingGroupFailure, (state, action) => ({
    ...state,
    updating: false,
    createError: action.error,
  }))
);
